import { Resources } from 'constants/resources';

import React from 'react';

import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { ReactComponent as CumulativeReport } from 'images/cumulativeReport.svg';
import { Link } from 'react-router-dom';
import { ContextMenuButton } from 'shared/mui/ContextMenu';
import { DEFAULT_TIMEZONE } from 'shared/mui/DatePicker/config/defaultValues';
import {
  DateRangeTimezoneValue,
  DateRangeValue,
} from 'shared/mui/DatePicker/DateTimeRangeTimezonePicker/DateTimeRangeTimezonePicker';
import {
  CompanyBalanceReport,
  MerchantAccountBalanceReport,
  MerchantBalanceReport,
  ProviderBalanceReport,
} from 'types/embedded/balanceReport';
import { formatInputToTimestamp } from 'utils/date';
import { convertReactAdminIdToHydraId } from 'utils/index';

type Props = {
  appliedDate?: DateRangeValue;
  timezone?: DateRangeTimezoneValue;
  merchantAccount: MerchantAccountBalanceReport;
  merchant: MerchantBalanceReport;
  provider: ProviderBalanceReport;
  company: CompanyBalanceReport;
};

export const ContextMenuCumulativeReportLink: React.FC<Props> = ({
  merchantAccount,
  provider,
  merchant,
  company,
  appliedDate,
  timezone,
}) => {
  const { createPathWithQuery } = useCreatePathWithQuery();
  const to = createPathWithQuery(
    {
      resource: Resources.CumulativeReport,
      type: 'list',
    },
    {
      filter: {
        company: convertReactAdminIdToHydraId(company.id, Resources.Companies),
        merchantAccounts: [convertReactAdminIdToHydraId(merchantAccount.id, 'merchant_accounts')],
        provider: convertReactAdminIdToHydraId(provider.id, Resources.Providers),
        merchant: convertReactAdminIdToHydraId(merchant.id, Resources.Merchants),
        currency: merchantAccount?.currencyCode,
        periodFrom: formatInputToTimestamp(appliedDate?.[0], { unit: 'seconds' }),
        periodTo: formatInputToTimestamp(appliedDate?.[1], { unit: 'seconds' }),
        timezone: timezone || DEFAULT_TIMEZONE,
      },
    },
  );

  return (
    <Link style={{ textDecoration: 'none' }} target="_blank" to={to}>
      <ContextMenuButton
        icon={<CumulativeReport />}
        label={'Нарастающий итог\nза выбранный период'}
      />
    </Link>
  );
};
